import { Box } from '@mui/material';
import { SyntheticEvent, useCallback, useState } from 'react';
import { TaskFilters, TasksFilters } from './components/TasksFilters';
import { TasksKanban } from './components/TasksKanban/TasksKanban';
import { TasksStatistics } from './components/TasksStatistics';
import { TasksTable } from './components/TasksTable';
import { useTasksData } from './hooks/useTasksData';

export const enum LayoutType {
  LIST = 'list',
  KANBAN = 'kanban',
}

export const TasksMain = () => {
  const currentRoleViewType =
    (sessionStorage.getItem('currentRoleViewType') as LayoutType) || LayoutType.KANBAN;
  const [layout, setLayout] = useState<LayoutType>(currentRoleViewType);
  const [tabValue, setTabValue] = useState<number>(0);
  const [filters, setFilters] = useState<TaskFilters>({
    priority: [],
    time: [],
    client: [],
    recordTypes: [],
    search: '',
    needAttention: false,
  });

  const { tasksData, loading, refetch } = useTasksData(tabValue === 0, filters);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = useCallback(() => {
    refetch();
    setRefreshTrigger((prev) => prev + 1);
  }, [refetch]);

  const handleLayoutChange = (_: SyntheticEvent, newValue: LayoutType) => {
    sessionStorage.setItem('currentRoleViewType', newValue);
    setLayout(newValue);
  };

  const handleTabChange = (newValue: number) => {
    setTabValue(newValue);
  };

  const handleApplyFilters = (newFilters: TaskFilters) => {
    setFilters(newFilters);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        margin: '24px',
        gap: '24px',
      }}
    >
      <TasksStatistics mine={tabValue === 0} filters={filters} />
      <TasksFilters
        onLayoutChange={handleLayoutChange}
        layout={layout}
        onTabChange={handleTabChange}
        tabValue={tabValue}
        onApplyFilters={handleApplyFilters}
        onRefresh={handleRefresh}
      />
      {layout === LayoutType.KANBAN ? (
        <TasksKanban
          mine={tabValue === 0}
          filters={filters}
          tasksData={tasksData}
          loading={loading}
          onRefresh={refetch}
        />
      ) : (
        <TasksTable mine={tabValue === 0} filters={filters} refreshTrigger={refreshTrigger} />
      )}
    </Box>
  );
};
